import { INBOX_EXPORT_COLUMNS, buildInboxExportFileName, mapConversationToExportRow } from "./inboxExport";

const XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const DATE_FORMAT = "mm/dd/yyyy";
const DATE_COLUMNS = [1, 2];
const WRAP_TEXT_COLUMNS = [5, 10]; // Client Name, Subject
const HEADER_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD4F1F4" } };

// The package entry pulls in Node streams, which the Webpack 4 build cannot bundle; the prebuilt browser bundle can.
const loadExcelJs = () => import("exceljs/dist/exceljs.min.js").then((module) => module.default || module);

// ExcelJS stores dates as UTC, so a local-midnight Date would land on the previous day east of UTC.
const toCellValue = (value) => {
  if (value instanceof Date) return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()));
  return value === "" ? null : value;
};

export const buildInboxWorkbook = async (conversations, member = {}, asOf = new Date()) => {
  const ExcelJS = await loadExcelJs();
  const workbook = new ExcelJS.Workbook();
  workbook.created = new Date();

  const worksheet = workbook.addWorksheet("CSR Inbox", {
    views: [{ state: "frozen", ySplit: 2, topLeftCell: "A3", activeCell: "A3" }],
  });
  worksheet.columns = INBOX_EXPORT_COLUMNS.map((column) => ({ header: column.header, width: column.width }));

  conversations.forEach((conversation) => {
    worksheet.addRow(mapConversationToExportRow(conversation, member, asOf).map(toCellValue));
  });
  DATE_COLUMNS.forEach((columnNumber) => {
    worksheet.getColumn(columnNumber).eachCell({ includeEmpty: false }, (cell, rowNumber) => {
      if (rowNumber > 1) cell.numFmt = DATE_FORMAT;
    });
  });
  WRAP_TEXT_COLUMNS.forEach((columnNumber) => {
    worksheet.getColumn(columnNumber).alignment = { wrapText: true, vertical: "top" };
  });

  worksheet.spliceRows(1, 0, [`Total messages: ${conversations.length}`]);
  worksheet.getRow(1).font = { bold: true };
  const header = worksheet.getRow(2);
  header.font = { bold: true };
  for (let column = 1; column <= INBOX_EXPORT_COLUMNS.length; column += 1) {
    header.getCell(column).fill = HEADER_FILL;
  }
  worksheet.autoFilter = {
    from: { row: 2, column: 1 },
    to: { row: worksheet.rowCount, column: INBOX_EXPORT_COLUMNS.length },
  };

  return workbook;
};

const downloadFile = (buffer, fileName) => {
  const url = URL.createObjectURL(new Blob([buffer], { type: XLSX_MIME_TYPE }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const exportInboxToExcel = async (conversations, member = {}, date = new Date()) => {
  const fileName = buildInboxExportFileName(date);
  const workbook = await buildInboxWorkbook(conversations, member, date);
  downloadFile(await workbook.xlsx.writeBuffer(), fileName);
  return fileName;
};
